import Vue from 'vue';
import Vuex from 'vuex';
import notifications from './modules/notifications';
import wizard from './modules/wizard-steps';
import dynamicEssForm from './modules/dynamic-ess-form';
import createNewReleaseForm from './modules/create-new-release-form';
import currencies from './modules/currencies';
Vue.use(Vuex);
Vue.config.devtools = true;

export default new Vuex.Store({
    modules: {
        notifications,
        wizard,
        dynamicEssForm,
        currencies,
        createNewReleaseForm,
    },
});
